var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBtnNavClose = function SvgBtnNavClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.894 18.879a.75.75 0 0 0 0-1.061l-5.833-5.834 5.833-5.833.067-.077a.75.75 0 0 0-1.127-.984L12 10.924 6.166 5.09l-.076-.067a.75.75 0 0 0-.984 1.128l5.833 5.833-5.833 5.834-.067.077a.75.75 0 0 0 1.127.984L12 13.045l5.834 5.834.076.067a.75.75 0 0 0 .984-.067Z",
    fill: "current"
  })));
};
export default SvgBtnNavClose;